import { AppointmentItem } from './appointment-item.model';
import { PromotionApplication } from './promotion-application.model';
import { GiftCard } from './gift-card.model';
import { CustomFieldAnswer } from './custom-field.model';

export enum AppointmentStatus {
  Cart = 'Cart',
  Booked = 'Booked',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Noshow = 'Noshow',
}

export enum AppointmentPaymentStatus {
  PayLater = 'PayLater', // Indicates payment is deferred but will be required later
  PartialPaymentRequired = 'PartialPaymentRequired', // A partial payment is required
  PartiallyPaid = 'PartiallyPaid', // Some portion of the payment has been made
  FullyPaid = 'FullyPaid', // The payment has been completed in full
  PaymentNotRequired = 'PaymentNotRequired', // No payment is required
}

export enum PaymentStatus {
  Paid = 'PAID',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export enum PaymentTypeEnum {
  Deposit = 'deposit',
  Now = 'now',
  Venue = 'venue',
  Full = 'full',
  SelfCheckout = 'self-checkout',
}

export interface Appointment {
  id: number;
  token?: string;
  locationId: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  date?: Date;
  servicesTotal?: number;
  discount?: number;
  deposit?: number;
  absorbFee?: boolean;
  bookingFee?: number;
  bookingFeeAmount?: number;
  totalPrice?: number;
  prePaidAmount?: number;
  currency: string;
  status: AppointmentStatus;
  paymentStatus: AppointmentPaymentStatus;
  /** Outcome of the latest payment attempt - set to pending when a checkout starts. */
  lastPaymentStatus?: PaymentStatus | null;
  appointmentItems: AppointmentItem[];
  giftCards?: GiftCard[];
  promotionApplications: PromotionApplication[];
  specialRequests?: string;
  customFieldAnswers?: CustomFieldAnswer[] | null;
  test: boolean;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
}
